module.exports = __webpack_public_path__ + "static/media/DocumentFlowIcon.a6addb4b.svg";